import React from "react";
import { useTranslation } from "react-i18next";

const NoResults = () => {
  const { t } = useTranslation();
  return (
    <div className="p-4 bg-4 bg-white">
      <h4>{t("curatorWorkspace.noResultsHeader")}</h4>
      <p>{t("curatorWorkspace.noResultsDesc")}</p>
    </div>
  );
};

export default NoResults;
